import { useState } from 'react';
import { Container, Divider, Typography } from '@mui/material';

import DetailItem from 'components/Staff/ItemDetail';
import Button from 'components/Common/Button';

import { dateFormat, findValuesByKeys } from 'utils/helpers';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import { notify } from 'components/Common/Toast';
import { useDispatch } from 'react-redux';
import { updateBasketStatus } from 'redux/slices/baskets/givingBasketSilce';
import { AppDispatch } from 'redux/store';
interface BasketDetailProp {
    basketDetails?: any;
}

function BasketDetailContainer({ basketDetails }: BasketDetailProp) {
    const { name, subType, description, nextPlannedStatusDate, company, status } = basketDetails || {};
    const { profileItems } = company || {};
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const navigate = useNavigate();
    const keys = ['TELEPHONE'];
    const attributes: any = findValuesByKeys(profileItems || [], keys) ?? {};
    const { TELEPHONE } = attributes;
    const dispatch = useDispatch<AppDispatch>();
    const toggleBasketStatus = async () => {
        const { id } = basketDetails;
        try {
            setIsLoading(true);
            const _status = status === 'SUSPEND' ? 'ACTIVE' : 'SUSPEND';
            const response: any = await dispatch(updateBasketStatus({ status: _status, id }));
            if (response?.payload?.code === 200) {
                if (status === 'SUSPEND') {
                    notify('Basket reactivated successfully!', 'success');
                } else {
                    notify('Basket suspended successfully!', 'success');
                }
                navigate(routes.home.main);
            }
        } catch (error) {
            console.log('SuspendBasket error', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container>
            <Container sx={{ p: 3, mt: 2 }}>
                <Typography sx={{ fontSize: 18, fontWeight: 400, mb: 1 }}>Basket Details</Typography>
                <Divider />
                <div style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
                    <DetailItem labelWidth={'15%'} label={'Title'} value={name} />
                    <DetailItem labelWidth={'15%'} label={'Type'} value={subType} />
                    <DetailItem labelWidth={'15%'} label={'Contact'} value={TELEPHONE ?? ''} />
                    <DetailItem
                        labelWidth={'15%'}
                        label={'Date & Time'}
                        value={nextPlannedStatusDate ? dateFormat(nextPlannedStatusDate) : '-- -- --'}
                    />
                    <DetailItem labelWidth={'15%'} label={'Details'} value={description} />
                </div>
                {!(status === 'PENDING' || status === 'CLOSED') && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 12 }}>
                        <Button
                            title={status === 'SUSPEND' ? 'Reactive Basket' : 'Suspend Basket'}
                            loading={isLoading}
                            onClick={() => {
                                toggleBasketStatus();
                            }}
                            sx={{ width: { xs: '60%' } }}
                        />
                    </div>
                )}
            </Container>
        </Container>
    );
}

export default BasketDetailContainer;
